interface ApplicationLogoProps {
    className?: string;
}

export default function ApplicationLogo({ className = "" }: ApplicationLogoProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 688.5 783"
        >
            <g>
                <g>
                    <path
                        fill="#3fc5c2"
                        d="M488.9,430.1c20.6,0,41.3,0,61.9,0c16.2,0,32.2,1.3,48,5.2c21.2,5.2,39.6,15.5,54.9,30.9
    c7.1,7.1,12.3,15.7,16.9,24.5c12.6,24.1,15.2,50,12.4,76.7c-2.1,20.4-9.4,38.7-21.1,55.4c-7.3,10.3-17,18.3-27.4,25.2
    c-16.7,11.1-35.3,17.4-55,19.8c-11.7,1.4-23.6,1.4-35.4,1.5c-22.7,0.2-45.3,0-68,0c-1.2,0-2.3,0-3.5,0c-4.8,0.1-5,0.2-5,5.2
    c0,20.5,0,41,0.1,61.5c0,11,0,22,0,33c0,0.7,0,1.3-0.1,2c-0.3,3.4-0.9,3.9-4.4,3.9c-8.2-0.1-16.3-0.2-24.5-0.2
    c-8.5,0-17,0-25.5,0.1c-5.2,0-5.8-0.4-5.8-5.5c0-25.1,0.1-50.3,0.2-75.4c0.1-10.6,0.4-21.3,0.4-31.9c0-29.4-0.1-58.8-0.1-88.3
    c0-16,0.1-31.9,0.1-47.9c0-16,0-31.9,0-47.9c0-14.5-0.1-28.9,0-43.4c0-4.4,0.2-4.5,4.3-4.5c13.3-0.1,26.6-0.2,39.9-0.2
    c12.1,0,24.3,0,36.4,0C488.9,430,488.9,430,488.9,430.1z M467.7,548.8C467.7,548.8,467.7,548.8,467.7,548.8c0.1,16,0,32,0.1,48
    c0,4.3,0.2,8.6,0.4,13c0.1,2.4,1.3,3.7,3.8,3.6c1,0,2,0,3,0c21.7,0,43.3,0.1,65-0.1c10.6-0.1,21.4,0.4,31.9-1.2
    c17.1-2.6,32-9.5,41.8-25c13.6-21.5,14.2-43.8,4.9-66.9c-2.5-6.2-6.5-11.8-11.5-16.2c-13.2-11.8-28.9-17.6-46.6-17.7
    c-28-0.3-56-0.2-84-0.2c-1.7,0-3.3,0-5,0.2c-3,0.3-3.6,1-3.8,4.1c-0.1,0.8,0,1.7,0,2.5C467.7,511.5,467.7,530.1,467.7,548.8z"
                    />
                </g>
            </g>
            <path
                fill="#3fc5c2"
                d="M322.5,21.5c-0.2-2.2-1.2-3.3-3.6-3.2c-2,0.1-4.1,0-6.1,0c-17.4,0-34.8,0-52.1,0.1c-27.7,0-55.5,0-83.2,0
	c-15.5,0-31.1,0-46.6,0c-5.2,0-10.4,0-15.6-0.1c-2.8-0.1-4.2,1.1-4.2,3.8c0,1.5,0,2.9,0,4.4c0,15.8-0.1,31.6-0.1,47.4
	c0,5.9-0.2,6.1-6.3,6.2l-56.2,0c-2.6,0-3.9,0.9-3.6,3.5c0.1,0.7,0,1.5,0,2.2c0,50.7,0,101.4,0,152.2c0,0,0,0,0.1,0
	c0,41.6,0,83.2,0,124.9c0,9.4-0.1,18.9-0.2,28.3c0,3.8,0.1,3.8,4.1,3.9c0.6,0,1.1,0,1.7,0c18.7-0.1,37.4-0.1,56.1-0.2
	c4.9,0,5.3-0.3,5.3-5.3c0-38,0-76,0-114c0-10.2,0-20.4,0-30.5c0-7,0-7,6.9-7c3.7,0,7.4,0,11.1,0c38.5,0,77.1,0,115.6,0
	c15.7,0,31.5-0.1,47.2-0.3c4.6-0.1,5-0.4,5-4.5c0.1-17.1,0.1-34.2,0-51.3c0-4.5-0.5-4.9-5.3-4.9c-6.1-0.1-12.2,0-18.3,0
	c-51.7,0-103.4,0-155.1,0c-7.3,0-7.3,0.1-7.4-7.3l0.1-80.7c0-8.1-1.9-8.9,9.2-8.8c20,0.2,40,0.4,60,0.5c22.6,0,45.2-0.1,67.8-0.2
	c23-0.1,45.9-0.1,68.9-0.2c4.6,0,4.6-0.1,4.7-4.5c0.1-17.3,0.2-34.5,0.3-51.8C322.8,23.3,322.6,22.4,322.5,21.5z"
            />
            <path
                fill="#3fc5c2"
                d="M474.5,328.5c0,3.2,0.9,4.3,4.2,4.6c3.3,0.2,6.7,0.1,10,0.1c58.2,0,116.4-0.1,174.6-0.1
	c5.9,0,6.4,0.5,6.3,6.1c-0.1,13.4-0.3,26.9-0.5,40.3c0,3.6,0.4,7.3,0.3,10.9c-0.1,3.9-1,4.6-5.1,4.6c-20-0.1-40-0.3-60-0.3
	c-61.3-0.1-122.7,0-184,0c-2.6,0-5.2,0.1-7.8,0.2c-4.5,0.1-4.6,0.1-4.8-4.6c-0.2-5.6-0.2-11.3-0.2-16.9c0-55.6,0-111.3,0-166.9
	c0,0-0.1,0-0.1,0c0-58.9,0-117.8,0-176.7c0-2.4,0-4.7,0.1-7.1c0.2-4,0.7-4.4,4.6-4.3c7.9,0.1,15.9,0.2,23.8,0.2
	c10.5,0,21.1,0,31.6-0.1c6.2,0,6.6,0.2,6.6,6.4"
            />
            <g>
                <path
                    fill="#3fc5c2"
                    d="M364.2,700.6c0,22.7,0,45.3,0,68c0,5.8-0.4,6.3-6.5,6.3c-19.6,0.1-39.1,0-58.7,0c-25.3,0-50.5,0-75.8,0
		c-7.4,0-7.6,0-7.7-7.6c-0.1-14.8-0.1-29.7-0.1-44.5c0-4.7,0.6-5.2,5.5-5.2c12.9,0,25.7,0,38.6-0.1c0.5,0,1,0,1.5-0.1
		c0.8-0.1,1.5-0.4,2.3-0.6c-0.3-0.8-0.4-1.9-1-2.5c-8.1-8-16.3-15.9-24.4-23.9c-4.2-4.1-8.4-8.1-12.6-12.3
		c-5.9-5.8-11.7-11.7-17.6-17.6c-7.5-7.5-14.9-15-22.4-22.5c-12.4-12.4-24.9-24.7-37.3-37.2c-11.5-11.5-22.8-23.2-34.3-34.7
		c-13.5-13.5-27.1-26.8-40.6-40.2c-9.7-9.6-19.3-19.3-29-29c-2.8-2.8-3-3.8-0.6-7.2c1.8-2.7,3.8-5.3,6-7.7
		c5.6-5.9,11.1-12,17.2-17.3c15.1-13.1,32-23.6,50.6-30.8c18.3-7,37.5-10.6,57.2-11.9c22.9-1.4,45.2,1.3,67.1,7.8
		C258,435,273,442.7,287.3,452c13.8,9,25.8,19.7,36.5,32.1c9.3,10.8,16.6,22.9,22.6,35.7c3.2,6.8,6.1,13.7,8.4,20.8
		c5.9,18.2,9.1,37,9.2,56.2c0,0.3,0,0.7,0,1c-0.1,4.3-0.5,4.8-4.8,4.8c-9.9,0.1-19.9,0-29.8,0c-6,0-12.1,0.1-18.1,0
		c-4.6-0.1-4.8-0.5-5.3-5.1c-0.7-7.3-1.2-14.6-2.3-21.9c-2.5-16-8.8-30.5-17.8-44c-11.5-17.3-26.5-30.5-44.7-39.9
		c-17.7-9.1-36.8-12.8-56.7-12.6c-19.7,0.2-38.4,5-56,13.8c-0.1,0.1-0.3,0.2-0.4,0.2c-4.1,2.2-4.2,2.5-0.8,5.8
		c17.5,17.7,35,35.4,52.7,53.1c19.3,19.4,38.7,38.6,58.2,57.9c11,10.9,22.1,21.7,33,32.6c9.2,9.2,18.4,18.5,27.6,27.6
		c1.6,1.6,3.4,3.1,5.1,4.5c1.3,1,2.2,0.4,2.3-1.1c0.2-2.6,0.2-5.2,0.2-7.8c0-11.2,0-22.5,0-33.7c0-5.2,0.3-5.4,5.6-5.4
		c15.8,0,31.6,0,47.4-0.1c4.5,0,4.8,0.1,4.8,4.5c0.1,16.9,0.1,33.9,0.1,50.8C364.2,688.2,364.2,694.4,364.2,700.6
		C364.2,700.6,364.2,700.6,364.2,700.6z"
                />
                <path
                    fill="#3fc5c2"
                    d="M179.3,774.8c-21.7-0.4-42.8-4.1-63-11.9c-23.2-9-43.9-22.1-61.1-40.3c-15.1-16-27.3-33.9-35.2-54.7
		C11.4,645.1,7,621.6,7.3,597.2c0.3-26.5,6.3-51.6,17.2-75.7c0.5-1,1-2.1,1.6-3c0.9-1.3,2.1-1.5,3.4-0.7c1.5,1,3,2,4.2,3.3
		c11.9,11.8,23.7,23.6,35.7,35.4c1.9,1.9,2.1,3.7,1.6,6.1c-1.5,6.7-3.2,13.3-4.2,20.1c-3,21-0.9,41.5,6.9,61.4
		c10.6,26.8,28.6,46.9,54.1,60.5c17.3,9.2,35.9,12.3,55,13.3c8.5,0.4,8.3-0.7,8.3,8.4c0.1,13.7,0.2,27.3,0.2,41
		c0,7.5-0.1,7.5-7.6,7.5C182.3,774.8,180.8,774.8,179.3,774.8z"
                />
            </g>
        </svg>
    );
}
